import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { SOCKET_URL, LOCAL_AUTH_JWT } from '../utils/constants';

/**
 * Subscribes to `tests-list-updated` pushes on the `realtime-tests` namespace
 * as a dashboard client. The server emits once on connect/reconnect, so this
 * hook on its own keeps the list in sync without any polling fallback.
 *
 * Pass `enabled = false` to keep the socket closed (e.g. while off the
 * central monitor view, which is rendered at both the home route and the
 * "View All" route).
 */
export default function useRealtimeTestsListSocket(onUpdate, enabled = true) {
    useEffect(() => {
        if (!enabled || !onUpdate) {
            console.log('[tests-list-socket] skipped (enabled=%s, hasCallback=%s)', enabled, !!onUpdate);
            return;
        }

        const token = localStorage.getItem(LOCAL_AUTH_JWT);
        console.log('[tests-list-socket] connecting to %s (hasToken=%s)', SOCKET_URL, !!token);

        const socket = io(SOCKET_URL, {
            transports: ['polling', 'websocket'],
            auth: {
                clientType: 'dashboard',
                token,
            },
        });

        socket.on('connect', () => {
            console.log('[tests-list-socket] connected (id=%s, namespace=%s)', socket.id, socket.nsp);
        });

        socket.on('disconnect', (reason) => {
            console.log('[tests-list-socket] disconnected (reason=%s)', reason);
        });

        socket.on('tests-list-updated', (tests) => {
            console.log('[tests-list-socket] tests-list-updated received (count=%d)', Array.isArray(tests) ? tests.length : -1, tests);
            onUpdate(tests);
        });

        socket.on('connect_error', (err) => {
            console.warn('[tests-list-socket] connect_error:', err.message);
        });

        socket.onAny((event, ...args) => {
            // Catch-all for any unexpected events from the server.
            if (event === 'tests-list-updated') return;
            console.log('[tests-list-socket] event=%s', event, args);
        });

        return () => {
            console.log('[tests-list-socket] cleanup — disconnecting');
            socket.disconnect();
        };
    }, [enabled, onUpdate]);
}
